module.exports = __webpack_public_path__ + "img/mystenlabs.7e04bd92.svg";